(function () {
  'use strict';
  /* HitchFire - persona gate companion: per-persona destination, auto-applied
     coupon, and the Meta pixel event.

     Deliberately a COMPANION script rather than an edit to hf-persona-gate.js.
     That file is minified into one 13KB line where a stray character is fatal,
     and it already exposes its live config object as window.HFPersonaGate.config
     plus a `hf_persona_selected` CustomEvent on window. So everything here is
     done from the outside: no risk to the gate itself, and deleting this one
     file reverts the behaviour completely. */

  var CODE = 'hitchfire10';
  var SHOP_ALL = '/collections/shop-hitchfire';

  var DEST = {
    tailgater:  '/pages/tailgating-grill',   // Tailgating & game day
    overlander: '/pages/overland-grill',     // Overlanding & off-road
    warrior:    '/pages/camping-grill',      // Camping & weekends
    rv:         '/pages/rv-grill',           // RV, trailer & van life
    athlete:    '/pages/trailhead-grill',    // Trailhead & tailgate-of-one
    other:      SHOP_ALL                     // Something else -> shop all
  };

  /* ---- Meta pixel -----------------------------------------------------
     Fires when the shopper PICKS a persona, not when they finish the email, so
     we capture everyone who engages rather than the minority who register.

     Event name is a custom event on purpose. No standard event honestly
     describes "clicked a category tile" — the closest, ViewContent, is already
     emitted by Shopify's Meta channel on every product page, and adding to it
     here would dilute a signal the RET campaign's audiences depend on. Since
     splitting by persona needs a Custom Conversion in Events Manager either
     way, a custom event costs nothing and keeps ViewContent clean. To switch to
     a standard event instead, change META_EVENT and 'trackCustom' -> 'track'.

     Trade-off to know: at click time there is no email, so Meta matches on the
     _fbp cookie, IP and user agent only. Match quality is lower than it would
     be after registration. A second CompleteRegistration event on email submit
     would carry the email — not built, ask if wanted.

     eventID is generated and stashed so a server-side CAPI call can later send
     the same event with the same id and have Meta dedupe the pair. */
  var META_EVENT = 'PersonaSelected';
  var META_METHOD = 'trackCustom';
  var otherText = '';

  function sessionGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessionSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ---- Show it once, ever ----------------------------------------------
     The gate's own rule is a SEVEN-DAY SNOOZE, not a one-time showing:
     closing it writes {dismissedAt} to localStorage.hfPersonaGate and it
     comes back a week later. Verified against the live gate - a dismissal
     8 days old brings it straight back, and so does picking a persona and
     then abandoning the email step.

     `completed: true` is the only flag that suppresses it permanently. Also
     verified: that flag on its own, with a 30-day-old dismissal, keeps the
     gate shut. So we set it the moment the modal is actually built. However
     the shopper leaves - the x, Esc, the scrim, signing up, or just
     navigating away mid-modal - they have had their one showing.

     Done from here rather than by editing hf-persona-gate.js, which is
     minified to a single line: deleting this file restores the 7-day snooze.

     Two details that matter:
     - Skipped when ?hfgate= forced it open, so testing never burns a real
       shopper's one showing (and so you can still QA it yourself).
     - The gate's dismissal write MERGES into the stored object rather than
       replacing it, so this flag survives being closed. */
  var STORE_KEY = 'hfPersonaGate';

  function markSeenForever() {
    if (/[?&]hfgate=/.test(location.search)) return;
    try {
      var raw = localStorage.getItem(STORE_KEY);
      var s = raw ? JSON.parse(raw) : {};
      if (s.completed) return;
      s.completed = true;
      s.completedAt = s.completedAt || Date.now();
      localStorage.setItem(STORE_KEY, JSON.stringify(s));
    } catch (e) {}
  }

  /* The modal is built on a 6s timer OR at 25% scroll, so it can appear well
     after this script runs. Poll rather than observe: one querySelector a
     second costs nothing, whereas a subtree MutationObserver on this page
     fires constantly. Stops as soon as it has marked. */
  function watchForOpen() {
    if (document.querySelector('.hfpg')) { markSeenForever(); return; }
    var openPoll = setInterval(function () {
      if (document.querySelector('.hfpg')) {
        clearInterval(openPoll);
        markSeenForever();
      }
    }, 1000);
  }

  function newEventId(key) {
    return 'hfpg-' + key + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function fireMeta(key) {
    if (!key) return;

    /* Only count a real click inside the popup. The gate also fires
       hf_persona_selected for visitors arriving with ?p= in the URL, with no
       modal ever built — counting those would inflate the event badly, since
       every click-through from a persona landing page carries ?p=. */
    if (!document.querySelector('.hfpg')) return;

    // One event per persona per session, so going Back and re-picking the same
    // tile doesn't double-fire. Picking a DIFFERENT persona does fire again.
    var sentKey = 'hfpg_meta_sent_' + key;
    if (sessionGet(sentKey) === '1') return;
    if (typeof window.fbq !== 'function') return;
    sessionSet(sentKey, '1');

    var id = newEventId(key);
    sessionSet('hfpg_meta_eid_' + key, id);

    var payload = { content_name: 'Persona gate', content_category: key, persona: key };
    if (key === 'other' && otherText) payload.persona_note = otherText;

    try { window.fbq(META_METHOD, META_EVENT, payload, { eventID: id }); } catch (e) {}

    // Mirror into the dataLayer so GTM (or a future server-side container) can
    // forward the identical event + id to the Conversions API.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hf_meta_persona',
        hf_meta_event: META_EVENT,
        hf_persona: key,
        hf_persona_note: (key === 'other' && otherText) ? otherText : null,
        hf_event_id: id
      });
    } catch (e) {}
  }

  /* Shopify's own discount route applies the code to the session, then forwards.
     The redirect target stays unencoded - same shape hf-pdp-atc.js already uses
     successfully on this store. */
  function withCoupon(path) {
    if (!CODE) return path;
    return '/discount/' + encodeURIComponent(CODE) + '?redirect=' + path;
  }

  function config() {
    return window.HFPersonaGate && window.HFPersonaGate.config;
  }

  function init() {
    var c = config();
    if (!c) return false;

    c.ctaLabel = 'Apply coupon and shop';
    c.successSub = 'Your 10% off is applied and waiting at checkout. The code is in your inbox too, and we will keep the recommendations pointed at how you roll.';
    c.ctaUrl = withCoupon(SHOP_ALL);

    // The gate fires hf_persona_other immediately AFTER hf_persona_selected, so
    // the free-text answer isn't readable yet when selection fires. Capture it
    // here and let fireMeta run a tick later to pick it up.
    window.addEventListener('hf_persona_other', function (ev) {
      otherText = (ev && ev.detail && ev.detail.hf_persona_text) || '';
    });

    // Fires on every pick, including going back and choosing again.
    window.addEventListener('hf_persona_selected', function (ev) {
      var key = ev && ev.detail && ev.detail.hf_persona;
      c.ctaUrl = withCoupon(DEST[key] || SHOP_ALL);
      setTimeout(function () { fireMeta(key); }, 0);
    });

    return true;
  }

  // The gate is deferred too; if it hasn't defined itself yet, wait it out.
  if (!init()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (init() || ++tries > 60) clearInterval(poll);
    }, 50);
  }

  // Independent of init(): even if the gate's config never turns up, a modal
  // that reached the screen still counts as the shopper's one showing.
  watchForOpen();
})();
